import React, { useState } from 'react';

const TreeTableRow = ({ warning,langLocal, translate, setOpenMaterial, setzone_idMat, data, depth, setOpen, setzone_id, setEditObj, setOpen1 }) => {
    const [expandedRows, setExpandedRows] = useState({});

    const toggleExpanded = (id) => {
        setExpandedRows(prevState => ({
            ...prevState,
            [id]: !prevState[id]
        }));
    };

    const [checked, setChecked] = useState(false);

    const handleCheckboxChange = () => {
        setChecked(!checked);
    };

    return (
        <>
            {data.map(item => (
                <React.Fragment key={item.id}>
                    <tr dir={langLocal === 'ar' ? "rtl" : "ltr"} >
                        <td style={{ width: "90px", textAlign: `${langLocal === 'ar' ? 'right' : 'left'}` }}>
                            <input type="checkbox" checked={checked} onChange={handleCheckboxChange} />
                        </td>
                        <td>
                            <div style={langLocal === 'ar' ? { marginRight: `${depth * 20}px`, cursor: 'pointer' } :
                                { marginLeft: `${depth * 20}px`, cursor: 'pointer' }}
                                onClick={() => toggleExpanded(item.id)}>
                                <div className='d-flex' >
                                    {item.name}
                                    {item.sub_zones && item.sub_zones.length > 0 && (
                                        <div onClick={() => toggleExpanded(item.id)} style={{ cursor: 'pointer' }}>
                                            <i style={langLocal === 'ar' ? { marginRight: "10px" } :
                                                { marginLeft: "10px" }
                                            } className={`fas fa-caret-${expandedRows[item.id] ? 'down' : 'right'}`}></i>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </td>
                        <td style={{ textAlign: `${langLocal === 'ar' ? 'right' : 'left'}` }}>
                            <span>{item.symbol}</span>
                        </td>
                        <td style={{ textAlign: `${langLocal === 'ar' ? 'right' : 'left'}` }}>
                            <i className='fa fa-eye' onClick={() => {
                                setzone_idMat(item.id)
                                setOpenMaterial(true)
                            }} ></i>
                        </td>
                        <td style={{ textAlign: `${langLocal === 'ar' ? 'right' : 'left'}` }}>
                            <div>
                                <i className='fa fa-plus plus_zone' onClick={() => {
                                    setOpen(true)
                                    setzone_id(item.id)
                                }} ></i>
                                <i onClick={() => warning(item)} style={langLocal === 'ar' ? { marginRight: "10px" } : { marginLeft: "10px" }} className='fa fa-trash del_zone' ></i>
                                <i style={langLocal === 'ar' ? { marginRight: "10px" } : { marginLeft: "10px" }} className='fa fa-edit edit_zone' onClick={() => {
                                    setEditObj(item)
                                    setzone_id(item.id)
                                    setOpen1(true)
                                }} ></i>
                            </div>
                        </td>

                    </tr>
                    {expandedRows[item.id] && item.sub_zones && item.sub_zones.length > 0 && (
                        <TreeTableRow warning={warning} langLocal={langLocal} translate={translate} setOpenMaterial={setOpenMaterial} setzone_idMat={setzone_idMat} setOpen1={setOpen1} data={item.sub_zones} depth={depth + 1} setOpen={setOpen} setzone_id={setzone_id} setEditObj={setEditObj} />
                    )}
                </React.Fragment>
            ))}
        </>
    );
};

function CustomTreeTable({ warning,langLocal, translate, setOpenMaterial, setzone_idMat, columns, data, open, setOpen, setzone_id, setEditObj, setOpen1 }) {
    return (
        <table className="tree-table">
            <thead >
                <tr >
                    {columns.map((column, index) => (
                        <th style={{ textAlign: `${langLocal === 'ar' ? 'right' : 'left'}` }} key={index}>{column}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {
                    data?.length >0 ?<TreeTableRow warning={warning} langLocal={langLocal} translate={translate} setOpenMaterial={setOpenMaterial} setzone_idMat={setzone_idMat} setOpen={setOpen} setzone_id={setzone_id} data={data} depth={0} setEditObj={setEditObj} setOpen1={setOpen1} />:
                    <div style={{position: "absolute",width: "100%", height: "150px",display: "flex" , alignItems: "center",justifyContent: "center",backgroundColor: "white"}} >There are no data</div>
                }
                
            </tbody>
        </table>
    );
}

export default CustomTreeTable;